<div id="order-details-container">
  <mat-toolbar class="mat-elevation-z8 header py-1" id="order-details-toolbar" *ngIf="order">
    <div class="d-flex align-items-center flex-wrap">
      <span>
        {{'ORDER_LIST.TITLE' | transloco}}
      </span>
      <span class="text-secondary px-2"> / </span>
      <span>
        {{ order.organizationName }}
      </span>
      <span class="text-secondary px-2"> / </span>
      <span class="me-3">
        Order {{order.orderNr}}
      </span>
      <span>
        <app-status-badge [text]="order.status" [isPayment]="true"></app-status-badge>
      </span>
    </div>
    <div>
      <span>
        {{order.orderDate | date: 'yyyy-MM-dd, '}}
      </span>
      <span class="text-secondary">
        {{order.orderDate | date: 'HH:mm'}}
      </span>
    </div>
  </mat-toolbar>
</div>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<!-- BUTTONS -->

<div class="container mt-3" *ngIf="order">

  <!-- Custom, highly responsive tab header to ensure iOS & iPadOS Safari clickability -->
  <nav class="custom-tabs-nav">
    <div class="custom-tab-list">
      <button type="button" class="custom-tab-link" [class.active]="selectedTabIndex === 0"
        (click)="onCustomTabChange(0)">
        {{ 'ORDER_DETAILS.TABS.OVERVIEW' | transloco }}
      </button>
      <button type="button" class="custom-tab-link" [class.active]="selectedTabIndex === 1"
        (click)="onCustomTabChange(1)">
        {{ 'ORDER_DETAILS.TABS.FINANCIAL_DETAILS' | transloco }}
      </button>
      <button type="button" class="custom-tab-link" [class.active]="selectedTabIndex === 2"
        (click)="onCustomTabChange(2)">
        {{ 'ORDER_DETAILS.TABS.ORDER_LOG' | transloco }}
      </button>
      <button type="button" class="custom-tab-link" [class.active]="selectedTabIndex === 3"
        (click)="onCustomTabChange(3)">
        {{ 'ORDER_DETAILS.TABS.QR' | transloco }}
      </button>
    </div>
  </nav>

  <div class="custom-tab-panels">
    <!-- Overview Tab Panel -->
    <div class="custom-tab-panel" *ngIf="selectedTabIndex === 0">

      @if (order.status === 'CheckoutAdditional' && order.debtReminders) {
        <div class="my-2 col debt-reminders">
          <span>{{ 'ORDER_LIST.DEBTS.ADDITIONAL_PAYMENT_SENT' | transloco }}: {{ (order.debtReminders.additionalPaymentSent | date:'yyyy-MM-dd') || '—' }}</span>
          <span>{{ 'ORDER_LIST.DEBTS.REMINDER_1' | transloco }}: {{ (order.debtReminders.debtReminder1Sent | date:'yyyy-MM-dd') || '—' }}</span>
          <span>{{ 'ORDER_LIST.DEBTS.REMINDER_2' | transloco }}: {{ (order.debtReminders.debtReminder2Sent | date:'yyyy-MM-dd') || '—' }}</span>
          <span>{{ 'ORDER_LIST.DEBTS.REMINDER_3' | transloco }}: {{ (order.debtReminders.debtReminder3Sent | date:'yyyy-MM-dd') || '—' }}</span>
        </div>
      }

      <div class="my-2 col buttons-container">
        <button *ngIf="order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="warn"
          (click)="setOrderstatusCancel(order.orderId)">
          <mat-icon>cancel</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.CANCEL_ORDER' | transloco}}
          </span>
        </button>
        <button *ngIf="order.status != 'Paid' && order.invoiceNr == null && canCreateInvoice" class="mr-2 mt-2"
          mat-stroked-button color="warn" (click)="createInvoice(this.order.orderId)">
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.CREATE_INVOICE' | transloco}}
          </span>
        </button>
        <button *ngIf="order.status === 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="warn"
          (click)="setOrderstatusPaid(order.orderId)">
          <mat-icon>restore_page</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.RESTORE_ORDER' | transloco}}
          </span>
        </button>

        <button *ngIf="order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderConfirmation(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_CONFIRMATION' | transloco}}
          </span>
        </button>

        <button *ngIf="order.status != 'Cancelled' && order.organizationName === 'Ving'" class="mr-2 mt-2"
          mat-stroked-button color="primary" (click)="sendVingOrderConfirmation(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_VING_CONFIRMATION' | transloco}}
          </span>
        </button>

        <button *ngIf="order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderAdditionalServiceOffer(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_ADDITIONAL_SERVICE_OFFER' | transloco}}
          </span>
        </button>

        <button *ngIf="order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderAdditionalPayment(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_ADDITIONAL_PAYMENT' | transloco}}
          </span>
        </button>

        @if (order.status === 'CheckoutAdditional' && !order.invoiceNr && order.debtReminders) {
          @for (reminderNr of [1, 2, 3]; track reminderNr) {
            @if (canSendDebtReminder(reminderNr)) {
            <button class="mr-2 mt-2" mat-stroked-button color="primary"
              (click)="sendDebtReminder(order.orderId, reminderNr)">
              <mat-icon>email</mat-icon>
              <span class="button-content">
                {{'ORDER_DETAILS.BUTTONS.SEND_DEBT_REMINDER' | transloco: { nr: reminderNr } }}
              </span>
            </button>
            }
          }
        }

        <button *ngIf="order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderWelcomeHome(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_WELCOME_HOME' | transloco}}
          </span>
        </button>
        <button *ngIf="order.status === 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderCancel(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_CANCELLATION_EMAIL' | transloco}}
          </span>
        </button>
        <button *ngIf="order.organizationName == 'Flygets.se' && order.status != 'Cancelled'" class="mr-2 mt-2"
          mat-stroked-button color="primary" (click)="sendParkingLPRCheckedInSMS(order.orderId)">
          <mat-icon>sms</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_CHECKED_IN_SMS' | transloco}}
          </span>
        </button>

        <button *ngIf="(orderParkingVM && orderParkingVM.parkingSiteName)
          || (orderRow?.orderParkings.length > 0 && orderRow?.orderParkings[0].parkingSiteName != '')
          && order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="sendOrderParkingCheckinConfirmation(order.orderId)">
          <mat-icon>email</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.SEND_PARKING_INSTRUCTIONS' | transloco}}
          </span>
        </button>
        
        <button *ngIf="order.status != 'Cancelled' &&
          !vehicleDetails &&
          !parkingIsSubscription &&
          (
            organization &&
            (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) ||
            myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId)) ||
            myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingSurveillance', $safeNavigationMigration(organization?.organizationParentId)))
          )
          " class="mr-2 mt-2" mat-stroked-button color="primary" (click)="getVehicleInfo(2)">
          <mat-icon>search</mat-icon>
          <span class="button-content">
            {{'VEHICLE_DETAILS.BUTTONS.GET_VEHICLE_INFO' | transloco}}
          </span>
        </button>
        <button *ngIf="order.status != 'Cancelled' &&
          vehicleDetails &&
          !parkingIsSubscription &&
          (
            organization &&
            (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) ||
            myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId)) ||
            myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingSurveillance', $safeNavigationMigration(organization?.organizationParentId)))
          )" class="mr-2 mt-2" mat-stroked-button color="primary" (click)="getVehicleInfo(3)">
          <mat-icon>refresh</mat-icon>
          <span class="button-content">
            {{'VEHICLE_DETAILS.BUTTONS.RENEW_VEHICLE_INFO' | transloco}}
          </span>
        </button>
        <button class="mr-2 mt-2" mat-stroked-button color="primary"
          *ngIf="orderParkingVM && order.status != 'Cancelled'"
          (click)="gotoCustomerPage(this.order.customer.email, order.orderNr)">
          <mat-icon>article_person</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.CUSTOMER_PAGE' | transloco}}
          </span>
        </button>
        <button *ngIf="order?.hasDevice" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="openNotificationForm(this.order.orderId)">
          <mat-icon>notifications</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.MOBILE_NOTIFICATION' | transloco}}
          </span>
        </button>

        <button *ngIf="(
              (orderParkingVM && orderParkingVM.parkingSiteName)
              || (orderRow?.orderParkings.length > 0
              && orderRow?.orderParkings[0].parkingSiteName != '')
            )
            && (!orderAdditionalServices ||  orderAdditionalServices.length === 0)
            && (!orderKeyTasks || orderKeyTasks.length === 0)
            && order.status != 'Cancelled'" class="mr-2 mt-2" mat-stroked-button color="primary"
          (click)="takeKeyFromCustomerNoAS()">
          <mat-icon>key</mat-icon>
          <span class="button-content">
            {{'ORDER_DETAILS.BUTTONS.TAKE_KEY_WITHOUT_AS' | transloco}}
          </span>
        </button>
      </div>

      <div class="row my-3">
        <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="!parkingIsSubscription">
          <!-- CUSTOMER -->
          <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
            <mat-toolbar class="card-header">
              <span class="card-header-content">
                <mat-icon class="card-header-icon me-2">supervisor_account</mat-icon>
                <span>
                  {{'CUSTOMER.TITLE' | transloco}}
                </span>
              </span>

              <mat-icon class="card-header-edit-icon clickable"
                (click)="editOrderCustomer(order.orderId)">edit_outline</mat-icon>
            </mat-toolbar>
            <div class="">
              <table mat-table [dataSource]="getCustomerInformation(this.order.customer)" class="responsive-table"
                [ngClass]="'cols-' + ['label', 'value'].length">

                <ng-container matColumnDef="label">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.label | transloco }} </td>
                </ng-container>

                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container
                      *ngIf="element.value === 'ORDER_DETAILS.ORDER_INFO.MISSING_ORDER_AT_SKAVSTA'; else normalValue">
                      {{ element.value | transloco }}
                    </ng-container>
                    <ng-template #normalValue>
                      <div class="value-container">
                        <span>{{ element.value }}</span>
                        <mat-icon *ngIf="element.label === 'CUSTOMER.EMAIL'" class="copy-icon"
                          (click)="copyToClipboard(element.label, element.value)">content_copy</mat-icon>
                      </div>
                    </ng-template>
                  </td>
                </ng-container>


                <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
              </table>
            </div>
          </mat-card>

          <!-- DISCOUNT -->
          <mat-card appearance="outlined" class="my-3 mat-elevation-z8"
            *ngIf="order.discountCode && order.discountCode?.toLowerCase() !== 'none'">
            <mat-toolbar class="card-header">
              <span class="card-header-content">
                <mat-icon class="card-header-icon me-2">sell</mat-icon>
                <span>Discount</span>
              </span>
            </mat-toolbar>
            <div class="">
              <table mat-table [dataSource]="[
                {label: 'PRICING.DISCOUNTCHECK.DISCOUNTCODE', value: order.discountCode},
                order.discountAmount ? {label: 'PRICING.DISCOUNTCHECK.DISCOUNTAMOUNT', value: order.discountAmount + ' Kr'} : {label: 'PRICING.DISCOUNTCHECK.DISCOUNTPERCENT', value: order.discountPercent + '%'}
              ]" class="responsive-table" [ngClass]="'cols-' + ['label', 'value'].length">
                <ng-container matColumnDef="label">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.label | transloco }} </td>
                </ng-container>
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.value }} </td>
                </ng-container>
                <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
              </table>
            </div>
          </mat-card>

          <!-- INVOICE -->
          <mat-card appearance="outlined" class="my-3 mat-elevation-z8" *ngIf="order.invoiceNr">
            <mat-toolbar class="card-header">
              <span class="card-header-content">
                <mat-icon class="card-header-icon me-2">receipt</mat-icon>
                <span>Invoice</span>
              </span>
            </mat-toolbar>
            <div class="">
              <table mat-table [dataSource]="[{label: 'Invoice Nr', value: order.invoiceNr}]" class="responsive-table"
                [ngClass]="'cols-' + ['label', 'value'].length">
                <ng-container matColumnDef="label">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.label | transloco }} </td>
                </ng-container>
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.value }} </td>
                </ng-container>
                <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
              </table>
            </div>
          </mat-card>

          <!-- VEHICLE -->
          <mat-card appearance="outlined" class="my-3 mat-elevation-z8" *ngIf="vehicleDetails || carId">
            <mat-toolbar class="card-header">
              <span class="card-header-content">
                <mat-icon class="card-header-icon me-2">directions_car</mat-icon>
                <span>
                  {{'VEHICLE_DETAILS.TITLE' | transloco}}
                </span>
              </span>
            </mat-toolbar>
            <div class="">
              <table *ngIf="vehicleDetails" mat-table [dataSource]="getVehicleInformation(this.vehicleDetails)"
                class="responsive-table" [ngClass]="'cols-' + ['label', 'value'].length">

                <ng-container matColumnDef="label">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.label | transloco }} </td>
                </ng-container>

                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{ element.value }} </td>
                </ng-container>

                <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
              </table>
              <div class="m-3">
                <h3 *ngIf="!vehicleDetails">{{'VEHICLE_DETAILS.NO_VEHICLE_DETAILS' | transloco}}</h3>
              </div>
            </div>
          </mat-card>
        </div>

        <div *ngIf="orderBundleRows|| orderShuttle || orderRow" class="col-lg-4 col-md-6 col-sm-12">
          <!-- PARKING SERVICE -->
          <ng-container *ngIf="orderBundleRows">
            <ng-container *ngFor="let bundle of orderBundleRows">
              <ng-container *ngIf="bundle.orderParkingVM" class="col">
                <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
                  <mat-toolbar class="card-header">
                    <span class="card-header-content">
                      <mat-icon class="card-header-icon me-2">local_parking</mat-icon>
                      <span>
                        {{bundle.productName}}
                        <small class="ms-2 text-muted">
                          3
                        </small>
                      </span>
                    </span>

                    <span>
                      <mat-icon class="card-header-edit-icon clickable"
                        (click)="editOrderParkingTime(bundle.orderParkingVM.orderParkingId)">access_time</mat-icon>
                      &nbsp;
                      <mat-icon class="card-header-edit-icon clickable"
                        (click)="editOrderParking(bundle.orderParkingVM.orderParkingId)">edit_outline</mat-icon>
                    </span>
                  </mat-toolbar>
                  <div class="">
                    <table mat-table [dataSource]="getBundleParkingDetailsData(bundle.orderParkingVM)"
                      class="w-100 responsive-table">

                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">{{ element.label | transloco }}</td>
                      </ng-container>

                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <ng-container *ngIf="element.isStatusBadge; else valueTemplate">
                            <app-status-badge [text]="element.value" [isPayment]="element.isPayment"></app-status-badge>
                          </ng-container>
                          <ng-template #valueTemplate>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_FROM'
                                              || element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_TO'
                                              || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_IN'
                                              || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_OUT'; else normalValue">
                              {{ element.value | date:'yyyy-MM-dd HH:mm' }}
                            </ng-container>
                            <ng-template #normalValue>
                              <div class="value-container">
                                <span>{{ element.value }}</span>
                                <mat-icon *ngIf="element.label == 'ORDER_DETAILS.PARKING_SERVICE.REGISTRATION_NUMBER'"
                                  class="copy-icon"
                                  (click)="copyToClipboard(element.label,element.value)">content_copy</mat-icon>
                              </div>
                            </ng-template>
                          </ng-template>
                        </td>
                      </ng-container>

                      <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                    </table>
                  </div>
                </mat-card>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- PARKING SERVICE -->
          <ng-container *ngIf="orderShuttle">
            <ng-container *ngFor="let bundle of orderRow.orderShuttles">
              <ng-container *ngIf="bundle.orderParkingVM" class="col">
                <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
                  <mat-toolbar class="card-header">
                    <span class="card-header-content">
                      <mat-icon class="card-header-icon me-2">local_parking</mat-icon>
                      <span>
                        {{bundle.productName}}
                        <small class="ms-2 text-muted">
                          4
                        </small>
                      </span>
                    </span>
                    <mat-icon class="card-header-edit-icon clickable"
                      (click)="editOrderParking(bundle.orderParkingVM.orderParkingId)">edit_outline</mat-icon>
                  </mat-toolbar>
                  <div class="">
                    <table mat-table [dataSource]="getBundleParkingDetailsData(bundle.orderParkingVM)"
                      class="w-100 responsive-table">

                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">{{ element.label | transloco }}</td>
                      </ng-container>

                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <ng-container *ngIf="element.isStatusBadge; else valueTemplate">
                            <app-status-badge [text]="element.value" [isPayment]="element.isPayment"></app-status-badge>
                          </ng-container>
                          <ng-template #valueTemplate>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_FROM'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_TO'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_IN'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_OUT'; else normalValue">
                              {{ element.value | date:'yyyy-MM-dd HH:mm' }}
                            </ng-container>
                            <ng-template #normalValue>
                              <div class="value-container">
                                <span>{{ element.value }}</span>
                                <mat-icon *ngIf="element.label == 'ORDER_DETAILS.PARKING_SERVICE.REGISTRATION_NUMBER'"
                                  class="copy-icon"
                                  (click)="copyToClipboard(element.label, element.value)">content_copy</mat-icon>
                              </div>
                            </ng-template>
                          </ng-template>
                        </td>
                      </ng-container>

                      <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                    </table>
                  </div>
                </mat-card>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- PARKING SERVICE -->
          <ng-container *ngIf="orderRow">
            <ng-container *ngFor="let parking of orderRow.orderParkings">
              <ng-container *ngIf="parking" class="col">
                <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
                  <mat-toolbar class="card-header">
                    <span class="card-header-content">
                      <mat-icon class="card-header-icon me-2"> local_parking</mat-icon>
                      <span>
                        {{parking.productName}}
                        <small class="ms-2 text-muted">
                          5
                        </small>
                      </span>
                    </span>

                    <span>
                      <mat-icon class="card-header-edit-icon clickable"
                        (click)="editOrderParkingTime(parking.orderParkingId)">access_time</mat-icon>
                      &nbsp;
                      <mat-icon class="card-header-edit-icon clickable"
                        (click)="editOrderParking(parking.orderParkingId)">edit_outline</mat-icon>
                    </span>
                  </mat-toolbar>
                  <div class="">
                    <table mat-table [dataSource]="getParkingDetailsData(parking)" class="w-100 responsive-table">

                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">{{ element.label | transloco }}</td>
                      </ng-container>

                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <ng-container *ngIf="element.isStatusBadge; else valueTemplate">
                            <app-status-badge [text]="element.value" [isPayment]="element.isPayment"></app-status-badge>
                          </ng-container>
                          <ng-template #valueTemplate>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_FROM'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.PARKING_TO'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_IN'
                                      || element.label === 'ORDER_DETAILS.PARKING_SERVICE.CHECK_OUT'; else normalValue">
                              {{ element.value | date:'yyyy-MM-dd HH:mm' }}
                            </ng-container>
                            <ng-template #normalValue>
                              <div class="value-container">
                                <span>{{ element.value }}</span>
                                <mat-icon *ngIf="element.label == 'ORDER_DETAILS.PARKING_SERVICE.REGISTRATION_NUMBER'"
                                  class="copy-icon"
                                  (click)="copyToClipboard(element.label, element.value)">content_copy</mat-icon>
                              </div>
                            </ng-template>
                          </ng-template>
                        </td>
                      </ng-container>

                      <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                    </table>
                  </div>
                </mat-card>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- LPR IMAGES -->
          <ng-container *ngIf="lprImages && lprImages?.length > 0">
            <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
              <mat-toolbar class="card-header">
                <span class="card-header-content">
                  <mat-icon class="card-header-icon me-2">photo_camera</mat-icon>
                  <span>
                    {{'LPR_IMAGES.TITLE' | transloco}}
                  </span>
                </span>
              </mat-toolbar>
              <div class="">
                <div *ngFor="let image of lprImages; let i = index"
                  class="lpr-image-container">
                  <div class="px-4 pt-2">
                    <!-- Image at top - full width -->
                    <div>
                      <img [src]="'data:image/' + image.format + ';base64,' + image.data" alt="LPR"
                        class="lpr-image-full">
                    </div>

                    <!-- Details table below - compact -->
                    <div class="py-1">
                      <table mat-table [dataSource]="[
                        {label: ('LPR_IMAGES.DIRECTION' | transloco), value: image.direction, type: 'direction'},
                        {label: ('LPR_IMAGES.LICENSE_PLATE' | transloco), value: image.licensePlate, type: 'plate'},
                        {label: ('LPR_IMAGES.CAMERA' | transloco), value: image.cam, type: 'text'},
                        {label: ('LPR_IMAGES.TIME' | transloco), value: image.created, type: 'date'}
                      ]" class="w-100 responsive-table lpr-table bg-transparent">
                        <ng-container matColumnDef="label">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element"> {{ element.label }} </td>
                        </ng-container>

                        <ng-container matColumnDef="value">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.type === 'direction'">
                              <span *ngIf="element.value === 1"
                                class="lpr-status-success">
                                <mat-icon class="icon-14">login</mat-icon>
                                {{'LPR_IMAGES.ENTRY' | transloco}}
                              </span>
                              <span *ngIf="element.value === 2"
                                class="lpr-status-error">
                                <mat-icon class="icon-14">logout</mat-icon>
                                {{'LPR_IMAGES.EXIT' | transloco}}
                              </span>
                            </span>
                            <span *ngIf="element.type === 'plate'" class="plate-text">{{
                              element.value }}</span>
                            <span *ngIf="element.type === 'text'">{{ element.value }}</span>
                            <span *ngIf="element.type === 'date'">{{ element.value | date:'yyyy-MM-dd HH:mm' }}</span>
                          </td>
                        </ng-container>

                        <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                      </table>
                    </div>
                  </div>
                  <hr class="seperator-line my-2 mx-3" *ngIf="lprImages?.length > 1 && i != lprImages?.length - 1">
                </div>
              </div>
            </mat-card>
          </ng-container>

        </div>

        <div class="col-lg-4 col-md-6 col-sm-12">
          <!-- ADDITIONAL SERVICES -->
          <div *ngIf="orderAdditionalServices && orderAdditionalServices.length > 0" class="col">
            <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
              <mat-toolbar class="card-header">
                <span class="card-header-content">
                  <mat-icon class="card-header-icon me-2">add_shopping_cart</mat-icon>
                  <span class="ps-2">
                    {{'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco}}
                  </span>
                </span>
                <mat-icon class="card-header-edit-icon clickable" (click)="addOrderAdditionalService()">add</mat-icon>
              </mat-toolbar>
              <div class="">
                <div class="mat-elevation-z1">
                  <table mat-table [dataSource]="orderAdditionalServices" class="w-100 responsive-table">
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef>{{'PRICING.ADDITIONAL_SERVICES.NAME' | transloco}}</th>
                      <td mat-cell *matCellDef="let service">{{service.name | translateAttribute}}</td>
                    </ng-container>

                    <!-- Planned Date Column -->
                    <ng-container matColumnDef="planned">
                      <th mat-header-cell *matHeaderCellDef>{{'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco}}</th>
                      <td mat-cell *matCellDef="let service">{{service.planned | date:'yyyy-MM-dd'}}</td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>{{'PRICING.ADDITIONAL_SERVICES.STATUS' | transloco}}</th>
                      <td mat-cell *matCellDef="let service">
                        <app-status-badge [text]="service.status"
                          [color]="getAdditionalServiceStatusColor(service.status)"></app-status-badge>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['name', 'planned', 'status']"></tr>
                    <tr mat-row (click)="editOrderAdditionalService(service)"
                      *matRowDef="let service; columns: ['name', 'planned', 'status'];"></tr>

                    <!-- Row shown when there is no matching data -->
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="3">{{'ORDER_DETAILS.ADDITIONAL_SERVICES.NO_DATA' | transloco}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card>
          </div>

          <!-- KEY SAFE -->
          <div
            *ngIf="vehicleKeyStoreTableRows && vehicleKeyStoreTableRows.length > 0 || orderAdditionalServices && orderAdditionalServices.length > 0"
            class="col">
            <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
              <mat-toolbar class="card-header">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="d-flex align-items-center">
                    <mat-icon class="me-2">key</mat-icon>
                    <span class="ps-2">
                      {{'VEHICLE_KEY_SAFE.KEY' | transloco}}
                    </span>
                  </div>
                </div>
                <mat-icon *ngIf="shouldShowAirTagIcon" class="clickable" (click)="editOrderVehicleKeyDetails()">
                  badge
                </mat-icon>
              </mat-toolbar>
              <div class="">
                <div *ngIf="vehicleKeyStoreTableRows && vehicleKeyStoreTableRows.length > 0 " class="mat-elevation-z1">
                  <table mat-table [dataSource]="vehicleKeyStoreTableRows" class="w-100 no-header-table">
                    <ng-container matColumnDef="labelWithNumber">
                      <td mat-cell *matCellDef="let element">{{element.labelWithNumber}}</td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                      <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.date">
                          {{element.date | date:'mediumDate'}}
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="details">
                      <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.details.status || element.details.status===0">
                          <app-status-badge *ngIf="!element.details.isAirTagStatus"
                            [text]="getSafeHookStatus(element.details.status).name"
                            [color]="getSafeHookStatus(element.details.status).color"></app-status-badge>
                          <app-status-badge *ngIf="element.details.isAirTagStatus"
                            [text]="getAirTagStatus(element.details.status).name"
                            [color]="getAirTagStatus(element.details.status).color"></app-status-badge>
                        </ng-container>
                        <ng-container *ngIf="element.details.action">
                          <button mat-flat-button color="primary"
                            *ngIf="highestTypeTask?.type === 1 && highestTypeTask?.status === 0 && highestTypeTask?.statusName !== 'Finished'"
                            (click)="markKeyTakenFromCustomerDone(highestTypeTask.id)">
                            {{ 'KEY_TASKS.TYPE_LABELS.3' | transloco }}
                          </button>
                          <button mat-flat-button color="primary"
                            *ngIf="highestTypeTask?.type === 1 && highestTypeTask?.status === 1 && highestTypeTask?.statusName !== 'Finished'"
                            (click)="markDriverTaskDone(highestTypeTask.id)">
                            {{ 'KEY_TASKS.TYPE_LABELS.1' | transloco }}
                          </button>
                          <button mat-flat-button color="primary"
                            *ngIf="highestTypeTask?.type === 2 && !highestTypeTask?.user"
                            (click)="markDriverTaskDone(highestTypeTask.id)">
                            {{ 'KEY_TASKS.TYPE_LABELS.2' | transloco }}
                          </button>
                        </ng-container>
                      </td>
                    </ng-container>
                    <tr mat-row class="cursor-default" *matRowDef="let row; columns: displayedKeyStoreColumns;"></tr>
                  </table>
                </div>
                <h3 class="m-3" *ngIf="vehicleKeyStoreTableRows && vehicleKeyStoreTableRows.length === 0 ">
                  {{ 'KEY_TASKS.VEHICLE_KEY_YET_TO_BE_ASSIGNED_SHAREBOX_OR_SAFEHOOK' | transloco}}
                </h3>
              </div>
            </mat-card>
          </div>

          <!-- SHUTTLE SERVICE -->
          <ng-container *ngIf="orderBundleRows">
            <ng-container *ngFor="let bundle of sortedOrderBundleRows">
              <div *ngIf="bundle.orderShuttleVM" class="col">
                <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
                  <mat-toolbar class="card-header">
                    <span class="card-header-content">
                      <mat-icon class="card-header-icon me-2"
                        *ngIf="bundle.productType == 'ShuttleDeparture'">flight_takeoff</mat-icon>
                      <mat-icon class="card-header-icon me-2"
                        *ngIf="bundle.productType == 'ShuttleArrival'">flight_land</mat-icon>
                      <span>
                        {{bundle.productName}} 1
                      </span>
                    </span>
                    <mat-icon class="card-header-edit-icon clickable"
                      (click)="editOrderShuttle(bundle.orderShuttleVM.orderShuttleId)">
                      edit_outline
                    </mat-icon>
                  </mat-toolbar>
                  <div class="">
                    <table mat-table [dataSource]="getShuttleDetailsData1(bundle.orderShuttleVM)"
                      class="w-100 responsive-table">
                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">{{ element.label | transloco }}</td>
                      </ng-container>

                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <ng-container *ngIf="element.isStatusBadge">
                            <app-status-badge [text]="element.value" [isPayment]="element.isPayment"></app-status-badge>
                          </ng-container>
                          <ng-container *ngIf="!element.isStatusBadge">
                            <ng-container *ngIf="element.label === 'ORDER_DETAILS.SHUTTLE_SERVICE.DATE'">
                              {{ element.value | date: 'yyyy-MM-dd HH:mm' }}
                            </ng-container>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.SHUTTLE_SERVICE.TYPE' && bundle.productType == 'ShuttleDeparture'">
                              {{ 'ORDER_DETAILS.SHUTTLE_SERVICE.TO' | transloco }}: {{ bundle.orderShuttleVM.terminal }}
                            </ng-container>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.SHUTTLE_SERVICE.TYPE' && bundle.productType == 'ShuttleArrival'">
                              {{ 'ORDER_DETAILS.SHUTTLE_SERVICE.FROM' | transloco }}: {{ bundle.orderShuttleVM.terminal
                              }}
                            </ng-container>
                            <ng-container
                              *ngIf="element.label !== 'ORDER_DETAILS.SHUTTLE_SERVICE.DATE' && element.label !== 'ORDER_DETAILS.SHUTTLE_SERVICE.TYPE'">
                              {{ element.value }}
                            </ng-container>
                          </ng-container>
                        </td>
                      </ng-container>

                      <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                    </table>
                  </div>
                </mat-card>
              </div>
            </ng-container>
          </ng-container>

          <!-- SHUTTLE SERVICE -->
          <ng-container *ngIf="orderShuttle">
            <ng-container *ngFor="let bundle of sortedOrderShuttles">
              <div *ngIf="bundle" class="col">
                <mat-card appearance="outlined" class="my-3 mat-elevation-z8">
                  <mat-toolbar class="card-header">
                    <span class="card-header-content">
                      <mat-icon class="card-header-icon me-2"
                        *ngIf="bundle.productType == 'ShuttleDeparture'">flight_takeoff</mat-icon>
                      <mat-icon class="card-header-icon me-2"
                        *ngIf="bundle.productType == 'ShuttleArrival'">flight_land</mat-icon>
                      <span>
                        {{bundle.shuttleTypeName}} 2
                      </span>
                    </span>
                    <mat-icon class="card-header-edit-icon clickable"
                      (click)="editOrderShuttle(bundle.orderShuttleId)">edit_outline</mat-icon>
                  </mat-toolbar>
                  <div class="">
                    <table mat-table [dataSource]="getShuttleDetailsData2(bundle)" class="w-100 responsive-table">

                      <ng-container matColumnDef="label">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">{{ element.label | transloco }}</td>
                      </ng-container>

                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <ng-container *ngIf="element.isStatusBadge; else valueTemplate">
                            <app-status-badge [text]="element.value" [isPayment]="element.isPayment"></app-status-badge>
                          </ng-container>
                          <ng-template #valueTemplate>
                            <ng-container
                              *ngIf="element.label === 'ORDER_DETAILS.SHUTTLE_SERVICE.DATE'; else normalValue">
                              {{ element.value | date:'yyyy-MM-dd HH:mm' }}
                            </ng-container>
                            <ng-template #normalValue>
                              {{ element.value }}
                            </ng-template>
                          </ng-template>
                        </td>
                      </ng-container>

                      <tr class="basic-info-row" mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
                    </table>
                  </div>
                </mat-card>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Financial Details Tab Panel -->
    <div class="custom-tab-panel" *ngIf="selectedTabIndex === 1">
      <app-back-office24-order-transaction [transactions]="orderTransactions$" [order]="order"
        [allAdditionalServices]="allAdditionalServices()" [orderAdditionalServices]="orderAdditionalServices"
        (createAdditionalService)="initializeForm()"></app-back-office24-order-transaction>
    </div>

    <!-- Order Log Tab Panel -->
    <div class="custom-tab-panel" *ngIf="selectedTabIndex === 2">
      <app-back-office24-order-log [orderId]="order.orderId"
        [loadData]="isOrderLogTabActive"></app-back-office24-order-log>
    </div>

    <!-- QR Tab Panel -->
    <div class="custom-tab-panel" *ngIf="selectedTabIndex === 3">
      <app-qr-generator [orderId]="order.orderId"></app-qr-generator>
    </div>
  </div>
</div>